/* import fares from 'config/fares';

const getFaresCollection = () => {
  const collection = new Map();

  fares.forEach((fare) => {
    collection.set(fare.code, fare);
  });
  return collection;
};
export default fares; */

// `config/fares` was removed and the implementation above commented out, so
// this collection has always been effectively empty. webpack tolerated the
// missing named export (consumers got `undefined`); Vite's strict ESM does
// not, so we export a real empty Map. `faresCollection.get(code)` returns
// undefined exactly as before — behavior is unchanged.
// eslint-disable-next-line import/prefer-default-export
export const faresCollection = new Map();
